const STORAGE_KEY = 'voxdub_user_preferences';

const DEFAULT_PREFERENCES = {
  // Paramètres de texte
  defaultFontSize: 20,
  defaultFontFamily: 'Arial',
  defaultFontColor: '#ffffff',
  defaultBackgroundImage: '/img/templates/br-dark-2.png',
  
  // Préférences UI
  displayMode: 'list',
  pageSize: 24,
  
  // Tailles des sections
  preserveWindowSizes: true,
  videoSectionWidth: 40,
  subtitleSectionWidth: 60,
  rythmoSectionHeight: 30,
  
  // Auto-save
  autoSaveEnabled: true,
  autoSaveInterval: 15,
};

class UserPreferencesService {
  constructor() {
    this.preferences = this.loadPreferences();
  }

  loadPreferences() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        return { ...DEFAULT_PREFERENCES, ...parsed };
      }
    } catch (error) {
      console.error('[UserPreferences] Error loading preferences:', error);
    }
    return { ...DEFAULT_PREFERENCES };
  }

  savePreference(key, value) {
    try {
      this.preferences[key] = value;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.preferences));
      return true;
    } catch (error) {
      console.error('[UserPreferences] Error saving preference:', error);
      return false;
    }
  }

  savePreferences(preferencesObj) {
    try {
      this.preferences = { ...this.preferences, ...preferencesObj };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.preferences));
      return true;
    } catch (error) {
      console.error('[UserPreferences] Error saving preferences:', error);
      return false;
    }
  }

  getPreference(key, defaultValue = null) {
    if (this.preferences.hasOwnProperty(key)) {
      return this.preferences[key];
    }
    if (DEFAULT_PREFERENCES.hasOwnProperty(key)) {
      return DEFAULT_PREFERENCES[key];
    }
    return defaultValue;
  }

  getAllPreferences() {
    return { ...this.preferences };
  }

  resetPreferences() {
    try {
      this.preferences = { ...DEFAULT_PREFERENCES };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.preferences));
      return true;
    } catch (error) {
      console.error('[UserPreferences] Error resetting preferences:', error);
      return false;
    }
  }

  clearPreferences() {
    try {
      localStorage.removeItem(STORAGE_KEY);
      this.preferences = { ...DEFAULT_PREFERENCES };
      return true;
    } catch (error) {
      console.error('[UserPreferences] Error clearing preferences:', error);
      return false;
    }
  }
}

const userPreferencesService = new UserPreferencesService();

export default userPreferencesService;
export { UserPreferencesService, DEFAULT_PREFERENCES };





